import {
    select,
    put,
    call,
    takeEvery, take
} from 'redux-saga/effects';
import { fromJS, List as IList } from 'immutable';
import { fetchFaceplateGroups, RETRIEVED_FACEPLATE_GROUPS, RETRIEVED_BRAND_CONFIG } from 'capi/redux';

import {
    REQUEST_FACEPLATE_GROUPS,
    FACEPLATE_PREFETCH_IMAGES,
    setFaceplateGroups,
    faceplatePrefetchImages, requestFaceplateGroups, SET_FACEPLATE_GROUPS, RESET_FACEPLATE_INFO,
    selectedCardType
} from './landingPageModule';
import { getIntlLocale } from '../intl/intlSelectors';
import { convertFaceplateGroupsToMap } from '../utils/landingPageUtils';
import { loadingAction } from '../loader/loaderModule';
import { SET_LOCALE } from '../intl/intlModule';
import { validateFaceplateCode } from '../routing/preferredValuesValidators';
import { preferredValueHandledAction } from '../routing/flowProgressModule';
import { IS_PLASTIC_FIELD, CARD_TYPES } from '../constants/constants';
import { getPreferredCardType, getPreferredFaceplateCode } from '../routing/flowSelectors';
import { isFaceplateInPreferredGroup, getSelectedCardType } from './landingPageSelectors';
import { changeCurrency, getCurrencyDefault } from '../intl/intlSagas';
import { getBrandElectronicCurrencyList, getBrandPlasticCurrencyList, getBrandSupportedCardTypes } from '../brand/brandSelectors';
import { getCartCurrencyCode } from '../productCartHandler/productCartSelectors';
import { getIsOldUiPreferred } from '../app/bootstrap';

export function* requestFaceplate(action) {
    const params = action.params || {};
    const intlLanguageCode = yield select(getIntlLocale);
    const languageCode = params.languageCode || intlLanguageCode;
    yield put(fetchFaceplateGroups({ languageCode }));
}

function* handleRetrievedFaceplates(action) {
    const { faceplateGroups } = action;
    const immutableFaceplateGroups = fromJS(faceplateGroups);
    yield put(setFaceplateGroups(immutableFaceplateGroups));

    yield put(loadingAction({ isLoading: false }));

    const preferredFaceplateCode = yield select(getPreferredFaceplateCode);

    
    if (preferredFaceplateCode) {
        const preferredFaceplate = action.faceplates.get(preferredFaceplateCode);
        if (preferredFaceplate) {
            const priorityImage = new Image();
            
            
            
            priorityImage.fetchPriority = 'high';
            priorityImage.src = preferredFaceplate.get('imageURL');
        }
    }

    
    if (getIsOldUiPreferred()) {
        const formattedFaceplateGroups = yield call(convertFaceplateGroupsToMap, immutableFaceplateGroups);
        yield put(faceplatePrefetchImages(formattedFaceplateGroups));
    }
}

function* prefetchImages(action) {
    
    yield action.faceplates.forEach((faceplate) => {
        const image = new Image();
        image.src = faceplate.get('imageURL');
    });

    
}

export function* validatePreferredFaceplateCode(faceplateCode) {
    const validatedFaceplateCode = validateFaceplateCode(faceplateCode);
    
    const { skipped } = yield take(preferredValueHandledAction(IS_PLASTIC_FIELD));
    if (skipped || !validatedFaceplateCode) {
        return null;
    }
    const cardType = yield select(getPreferredCardType);
    const isFaceplateCodeValid = (yield select(isFaceplateInPreferredGroup))(cardType, validatedFaceplateCode);
    return isFaceplateCodeValid ? validatedFaceplateCode : null;
}

export function* validatePreferredCurrencyCode(currencyCode) {
    const { skipped } = yield take(preferredValueHandledAction(IS_PLASTIC_FIELD));

    if (skipped || !currencyCode) {
        return null;
    }

    const cardType = yield select(getPreferredCardType);
    const supportedPlasticCurrencyList = yield select(getBrandPlasticCurrencyList);
    const supportedElectronicCurrencyList = yield select(getBrandElectronicCurrencyList);
    const cartCurrencyCode = yield select(getCartCurrencyCode);

    
    
    
    const defaultCurrency = cartCurrencyCode || getCurrencyDefault(
        supportedElectronicCurrencyList,
        currencyCode,
        cardType,
        supportedPlasticCurrencyList
    );

    
    yield call(changeCurrency, { currency: defaultCurrency });
    return defaultCurrency;
}

export function* defaultCardTypeFromBrandSupport() {
    
    const currentCardType = yield select(getSelectedCardType);
    if (currentCardType) {
        return;
    }

    const supportedCardTypes = yield select(getBrandSupportedCardTypes);
    const supportsDigital = supportedCardTypes.get('supportsDigitalCards');
    const supportsPhysical = supportedCardTypes.get('supportsPlasticCards');

    if (!supportsDigital && supportsPhysical) {
        yield put(selectedCardType(CARD_TYPES.Physical));
    }
}

export function* defaultCardTypeWatcher() {
    yield takeEvery(RETRIEVED_BRAND_CONFIG.CATALOG, defaultCardTypeFromBrandSupport);
}

export function* requestFaceplatesWatcher() {
    
    yield put(loadingAction({ isLoading: true }));
    yield takeEvery(REQUEST_FACEPLATE_GROUPS, requestFaceplate);
}

export function* faceplatesReceivedWatcher() {
    yield takeEvery(RETRIEVED_FACEPLATE_GROUPS, handleRetrievedFaceplates);
}

export function* faceplatePrefetchImagesWatcher() {
    yield takeEvery(FACEPLATE_PREFETCH_IMAGES, prefetchImages);
}

export function* updateFaceplatesForLanguage(action) {
    const { locale } = action;
    yield put({ type: RESET_FACEPLATE_INFO });
    
    yield put(setFaceplateGroups(IList()));
    yield put(requestFaceplateGroups({ languageCode: locale }));
    
    yield take(SET_FACEPLATE_GROUPS);
}


export function* updateFaceplatesForLanguageWatcher() {
    yield takeEvery(SET_LOCALE, updateFaceplatesForLanguage);
}
